export default __webpack_public_path__ + "static/media/thsarabunnew-webfont.971f7135.ttf";